export default __webpack_public_path__ + "static/media/sycamore2.b13aa18f.jfif";